const ColumnSelectFilterMenuTestIdsScope = {
  COLUMN_SELECT_FILTER: 'column-select-filter',
};

export const ColumnSelectFilterMenuTestIds = {
  TRIGGER: `${ColumnSelectFilterMenuTestIdsScope.COLUMN_SELECT_FILTER}.trigger`,
  CLEAR_BUTTON: `${ColumnSelectFilterMenuTestIdsScope.COLUMN_SELECT_FILTER}.clear-button`,
  CONFIRM_BUTTON: `${ColumnSelectFilterMenuTestIdsScope.COLUMN_SELECT_FILTER}.confirm-button`,
  getOptionId: value =>
    `${ColumnSelectFilterMenuTestIdsScope.COLUMN_SELECT_FILTER}.option-${value}`,
  getOptionCheckboxId: value =>
    `${ColumnSelectFilterMenuTestIdsScope.COLUMN_SELECT_FILTER}.option-checkbox-${value}`,
};
